import Sphere from './sphere.component';
export default Sphere;
